"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _printableWorksheets = require("printableWorksheets");
var _react = _interopRequireWildcard(require("react"));
var _events = _interopRequireDefault(require("./events"));
var _state = require("./state");
var _DownloadedScreen = _interopRequireDefault(require("./components/views/DownloadedScreen"));
var _SavedScreen = _interopRequireDefault(require("./components/views/SavedScreen"));
var _SearchScreen = _interopRequireDefault(require("./components/views/SearchScreen"));
var _AppMediaProvider = require("../baseStyles/AppMediaProvider");
var _Printables = _interopRequireDefault(require("./components/views/Printables"));
require("./styles.scss");
var _common = require("apps/teacher/config/common");
var _wsPreview = _interopRequireDefault(require("./components/worksheetsView/wsPreview"));
var _baseUrls = _interopRequireDefault(require("apps/teacher/config/baseUrls"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PrintableWorksheetsView = function PrintableWorksheetsView() {
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    activeGrade = _usePrintableWorkshee.activeGrade,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    onboardingGrade = _usePrintableWorkshee.onboardingGrade,
    activeScreen = _usePrintableWorkshee.activeScreen,
    envProps = _usePrintableWorkshee.envProps;
  var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
    currentDevice = _useAppMediaProvider.currentDevice,
    isMobile = _useAppMediaProvider.isMobile,
    isDesktop = _useAppMediaProvider.isDesktop;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    showWorksheetPreview = _useState2[0],
    setShowWorksheetPreview = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    wsDetailsViaOnboarding = _useState4[0],
    setWsDetailsViaOnboarding = _useState4[1];
  (0, _react.useEffect)(function () {
    if ((0, _common.hasSignedUpFromWs)() && (0, _common.isSignedUpFromWsDetail)() && isDesktop) {
      localStorage.setItem('wsPreviewShownViaOnboarding', 'true');
      var schoolUiHost = (0, _common.isFlutterUser)() ? window.parent.parent.SCHOOL_UI_ASSET_HOST : window.SCHOOL_UI_ASSET_HOST;
      var ws_details = JSON.parse(localStorage.getItem('ws_details'));
      var fromWsList = localStorage.getItem("clickedWsFromListPage");
      var signupPageUrl = fromWsList ? localStorage.getItem("wsLinkUrl") : sessionStorage.getItem('signup_page_url') || '';
      var imageUrl = _baseUrls["default"].cms_image_asset_url + signupPageUrl + '.jpeg';
      var gradesAndStandard = ws_details.ws_grade_tags;
      var subject = ws_details.ws_subject_tag;
      var topics = ws_details.ws_topic_tags;
      var pdf_folder = "https://".concat(schoolUiHost.includes("staging") ? "f2" : "www", ".splashlearn.com/worksheet_uploads/pdf/");
      var obj = {
        id: ws_details.ws_id,
        title: ws_details.ws_title,
        description: ws_details.ws_description,
        image_url: imageUrl,
        grades: gradesAndStandard,
        subject_and_topics: [subject].concat(_toConsumableArray(topics)),
        pdf_url: pdf_folder + signupPageUrl + '.pdf',
        code: ws_details.ws_code
      };
      setWsDetailsViaOnboarding(obj);
      if (window.parent.triggerIsFlutterHeaderClickDisabled) {
        window.parent.triggerIsFlutterHeaderClickDisabled();
      }
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (worksheetsEnvironment) {
      fireMountEvent();
      if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD && isMobile) {
        document.body.style.margin = "0px";
        document.body.style.height = "100%";
      }
    }
  }, [worksheetsEnvironment]);
  var fireMountEvent = function fireMountEvent() {
    switch (worksheetsEnvironment) {
      case _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD:
        {
          var props = {
            worksheetGrade: activeGrade
          };
          _events["default"].clickedWorksheetTab(props);
        }
        break;
      case _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD:
        {
          var _envProps$params;
          var _props = {
            dashboardVersion: envProps === null || envProps === void 0 || (_envProps$params = envProps.params) === null || _envProps$params === void 0 || (_envProps$params = _envProps$params.settings) === null || _envProps$params === void 0 ? void 0 : _envProps$params.tileDashboardVersion,
            tabCode: envProps === null || envProps === void 0 ? void 0 : envProps.activeHeaderTabId,
            grade: onboardingGrade,
            from: '',
            worksheetCode: ''
          };
          _events["default"].viewedTiledDashboard(_props);
        }
    }
  };
  var activeScreenToBeDisplayed = (0, _react.useMemo)(function () {
    switch (activeScreen) {
      case _state.PRINTABLE_WORKSHEET_SCREENS.DEFAULT:
        return /*#__PURE__*/_react["default"].createElement(_Printables["default"], null);
      case _state.PRINTABLE_WORKSHEET_SCREENS.SAVED:
        return /*#__PURE__*/_react["default"].createElement(_SavedScreen["default"], null);
      case _state.PRINTABLE_WORKSHEET_SCREENS.DOWNLOADED:
        return /*#__PURE__*/_react["default"].createElement(_DownloadedScreen["default"], null);
      case _state.PRINTABLE_WORKSHEET_SCREENS.SEARCH:
        return /*#__PURE__*/_react["default"].createElement(_SearchScreen["default"], null);
      default:
        return /*#__PURE__*/_react["default"].createElement(_Printables["default"], null);
    }
  }, [activeScreen]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showWorksheetPreview && (0, _common.isSignedUpFromWsDetail)() && isDesktop && /*#__PURE__*/_react["default"].createElement(_wsPreview["default"], {
    worksheetDetails: wsDetailsViaOnboarding,
    setShowWorksheetPreview: setShowWorksheetPreview,
    showWorksheetPreview: showWorksheetPreview
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "printable-worksheets device-".concat(currentDevice, " w-env-").concat(worksheetsEnvironment),
    ref: function ref(_ref) {
      if (_ref && !isMobile) {
        var elementDetails = _ref.getBoundingClientRect();
        _ref.style.height = "calc(100vh - ".concat(elementDetails.top + 20, "px)");
      }
    }
  }, activeScreenToBeDisplayed));
};
var _default = exports["default"] = PrintableWorksheetsView;